import { Component, inject } from '@angular/core';
import { LanguageService } from '../../services/language.service';

@Component({
	selector: 'app-language-selector',
	template: `
		@for (lang of languages; track lang.code) {
			@if (!$first) {
				<span class="lang-divider">|</span>
			}
			<button
				class="lang-btn"
				[class.lang-btn--active]="currentLang() === lang.code"
				(click)="setLanguage(lang.code)"
				[attr.aria-label]="lang.label"
			>
				{{ lang.label }}
			</button>
		}
	`,
	styleUrl: './language-selector.component.scss',
})
export class LanguageSelectorComponent {
	private languageService = inject(LanguageService);

	public currentLang = this.languageService.currentLang;

	public readonly languages = [
		{ code: 'es', label: 'ES' },
		{ code: 'en', label: 'EN' },
		{ code: 'pt', label: 'PT' },
	];

	public setLanguage(lang: string): void {
		this.languageService.setLanguage(lang);
	}
}
